type OwnProps = {
  id?: string;
  message?: string | $TSFixMe[];
  className?: string;
  iconClassName?: string;
};

const defaultProps: Partial<OwnProps> = {
  id: "banner",
  message: "",
  className: "navigation-banner",
  iconClassName: "lcm-iot-icon-info",
};

type Props = OwnProps & typeof defaultProps;

function NavigationBanner({
  id,
  iconClassName,
  className,
  message, // , onClick, { a: htmlButton(() => deactivate()) }
}: Props) {
  return (
    <div id={id} className="cyan-stripe">
      <div className={className}>
        <div>
          <span className={iconClassName} />
          <p id="banner-message">{message}</p>
        </div>
      </div>
    </div>
  );
}
NavigationBanner.defaultProps = defaultProps;

export default NavigationBanner;
